import React, { useRef, useState } from "react";
import { GrUpload } from "react-icons/gr";

export default function FileDropZone({
  onFile, onError, error, validate = () => true, disabled = false,
  accept = ".pdf,.png,.jpg,.jpeg", formats = "PDF, PNG, JPG",
  busyText = "Datei wird verarbeitet…", className = "", children,
}) {
  const [dragging, setDragging] = useState(false);
  const dragDepth = useRef(0);
  const fileInputRef = useRef(null);

  function selectFiles(files) {
    if (disabled || !files.length) return;
    if (files.length !== 1) return onError("Bitte nur eine Datei hochladen.");
    const file = files[0];
    const allowed = accept.split(",").some((type) => {
      type = type.trim().toLowerCase();
      if (type.startsWith(".")) return file.name.toLowerCase().endsWith(type);
      return type.endsWith("/*") ? file.type.startsWith(type.slice(0, -1)) : file.type === type;
    });
    if (!allowed) return onError(`Bitte eine Datei in einem dieser Formate auswählen: ${formats}.`);
    if (!validate()) return;
    onError("");
    onFile(file);
  }

  return (
    <div
      onDragEnter={(e) => {
        e.preventDefault();
        if (disabled || !Array.from(e.dataTransfer.types).includes("Files")) return;
        dragDepth.current += 1;
        setDragging(true);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = disabled ? "none" : "copy";
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        dragDepth.current = Math.max(0, dragDepth.current - 1);
        if (dragDepth.current === 0) setDragging(false);
      }}
      onDrop={(e) => {
        e.preventDefault();
        dragDepth.current = 0;
        setDragging(false);
        selectFiles(Array.from(e.dataTransfer.files));
      }}
      aria-busy={disabled}
      className={`rounded-lg border-2 border-dashed p-6 text-center transition-colors ${
        dragging && !disabled ? "border-blue-500 bg-blue-100" : "border-blue-300 bg-white/50"
      } ${className}`}
    >
      {error && <div role="alert" className="mb-3 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">{error}</div>}
      {children}
      <GrUpload className="mx-auto mb-3 text-4xl" />
      <div className="mb-3 text-sm text-gray-700" aria-live="polite">
        {disabled ? busyText : dragging ? "Datei hier ablegen" : "Datei hierher ziehen oder auswählen"}
      </div>
      <input
        ref={fileInputRef} type="file" accept={accept} disabled={disabled} className="hidden"
        onChange={(e) => {
          const files = Array.from(e.target.files || []);
          e.target.value = "";
          selectFiles(files);
        }}
      />
      <button
        type="button" disabled={disabled}
        onClick={() => { if (validate()) fileInputRef.current?.click(); }}
        className="rounded-xl bg-[#84bbff] px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#5d9ef7] disabled:opacity-60"
      >
        {disabled ? "Lädt hoch…" : "Datei auswählen"}
      </button>
      <div className="mt-3 text-xs text-gray-600">{formats} · Eine Datei pro Upload</div>
    </div>
  );
}
